import { elementType, shape, string } from "prop-types";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { useGetBanksQuery } from "web/features/pointsBank/pointsBankApiSlice";

import PanelItem from "./panelItem";

const PanelItemContainer = ({ item }) => {
  const { pathname } = useLocation();
  const { data: dataBanks } = useGetBanksQuery();
  const { total: totalPoints } = dataBanks || {};

  const { pageType, isNavigationOpened } = useSelector((state) => state.app);

  return (
    <PanelItem
      item={item}
      pathname={pathname}
      pageType={pageType}
      totalPoints={totalPoints}
      isNavigationOpened={isNavigationOpened}
    />
  );
};

PanelItemContainer.propTypes = {
  item: shape({
    id: string.isRequired,
    name: string.isRequired,
    link: string.isRequired,
    icon: elementType.isRequired,
  }).isRequired,
};

export default PanelItemContainer;
